// One-line import for all UI primitives.
// Usage: import { Card, Stat, Badge, Section, Button } from '@/components/ui';

export { Card }         from './Card';
export { Stat }         from './Stat';
export { Badge }        from './Badge';
export { Pill }         from './Pill';
export { ProgressBar }  from './ProgressBar';
export { Section }      from './Section';
export { SectionTitle } from './SectionTitle';
export { SectionHeading } from './SectionHeading';
export { IconTile }     from './IconTile';
export { Avatar }       from './Avatar';
export { Button }       from './Button';
export { Container }    from './Container';

// Marketing-page canonical building blocks (homepage design language).
export { BookDemoButton }      from './BookDemoButton';
export { FaqAccordion }        from './FaqAccordion';
export { PageHero }            from './PageHero';
export { PageSection }         from './PageSection';
export { CheckList, CheckRow } from './CheckList';
export { Reveal, RevealItem }  from './Reveal';

// Keep existing accordion export
export * from './accordion';
